<template>
  <v-app class="lightBlue">
    <v-container>
      <v-row align="start" class="d-flex flex-column" justify="space-between">
        <v-col class="col-12 col-md-6 col-lg-3 col-xl-3">
          <v-select
            hide-details
            solo
            label="Prontuários"
            :items="searchOptionsItems"
            v-model="searchMode"
            item-text="title"
            item-value="value"
            @input="getDataFromSearchMode"
            background-color="#fff"
            color="primary"
            :prepend-inner-icon="iconSelect"
          ></v-select>
        </v-col>
        <div v-if="searchMode === 'medicalRecords'" class="search-records">
          <div class="card-container-filter">
            <img
              class="filter-position-two"
              v-if="filterFocused"
              :src="require('../../assets/filter-focused.svg')"
            />
            <img class="filter-position-two" v-else :src="require('../../assets/filter.svg')" />
            <v-text-field
              hide-details
              solo
              full-width
              v-model="dataSearch.name"
              label="Busque pelo nome do paciente"
              required
              prepend-inner-icon="filt"
              @focus="() => (filterFocused = true)"
              @blur="() => (filterFocused = false)"
              background-color="#fff"
            ></v-text-field>
          </div>
          <div class="card-input">
            <DatePicker
              label="Data início"
              :isFlat="false"
              background="#fff"
              :isRequired="false"
              v-on:date="saveDate($event, 'beginningDate')"
            />
          </div>
          <div class="card-input">
            <DatePicker
              label="Data fim"
              :isFlat="false"
              background="#fff"
              :isRequired="false"
              v-on:date="saveDate($event, 'finishDate')"
            />
          </div>
          <v-btn
            color="primary"
            class="lato-black white--text text-transform-none br-10"
            height="40"
            @click="clearForm"
          >
            Limpar filtro
          </v-btn>
          <v-btn
            color="secondary"
            class="lato-black white--text text-transform-none br-10"
            height="40"
            @click="getMyMedicalRecords"
          >
            Filtrar
          </v-btn>
        </div>
        <div v-if="searchMode === 'patients'" class="search-patients">
          <div>
            <div class="card-container-filter">
              <img
                class="filter-position"
                v-if="filterFocused"
                :src="require('../../assets/filter-focused.svg')"
              />
              <img class="filter-position" v-else :src="require('../../assets/filter.svg')" />
              <v-text-field
                hide-details
                solo
                v-model="searchNamePatient"
                label="Busque pelo nome do paciente"
                required
                prepend-inner-icon="filt"
                @focus="() => (filterFocused = true)"
                @blur="() => (filterFocused = false)"
                background-color="#fff"
              ></v-text-field>
            </div>
            <v-btn
              color="secondary"
              class="lato-black white--text text-transform-none br-10"
              height="40"
              @click="getListPatients(searchNamePatient)"
            >
              Filtrar
            </v-btn>
          </div>
        </div>
      </v-row>

      <v-row class="justify-center align-center flex-column fill-height" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </v-row>

      <div v-if="searchMode === 'patients'">
        <v-row justify="center" v-if="!isLoading && listPatients.length === 0">
          <v-col class="col-12 col-md-6 col-lg-4">
            <h2 class="text-center primary--text">Você não possui Pacientes.</h2>
          </v-col>
        </v-row>

        <v-row v-if="!isLoading && listPatients.length > 0">
          <v-col
            v-for="(item, index) in createPagination(listPatients)[pagePatient - 1]"
            :key="index"
            class="col-12 col-md-6 col-lg-4"
          >
            <div
              class="yellow pa-5 d-flex flex-column flex-md-row align-center justify-space-between"
            >
              <v-avatar size="90" class="mr-md-3">
                <v-img v-if="item.photo" :src="item.photo"></v-img>
                <v-icon size="70" class="white" v-else>person</v-icon>
              </v-avatar>
              <p class="mb-0 mt-5 mt-md-0">
                {{ item.name }}
              </p>
              <v-btn
                :to="{
                  name: 'PatientProfileView',
                  params: { id: item.id },
                }"
                rounded
                class="mt-1 mt-md-0 ml-md-3"
              >
                Ver Perfil
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="searchMode === 'medicalRecords'">
        <v-row justify="center" v-if="!isLoading && listRecords.length === 0">
          <v-col class="col-12 col-md-6 col-lg-4">
            <h2 class="text-center primary--text">Você não possui prontuários.</h2>
          </v-col>
        </v-row>

        <div v-if="!isLoading && listRecords.length > 0" class="grid-records">
          <div
            v-for="(item, index) in createPagination(listRecords)[pageRecord - 1]"
            :key="index"
            class="grid-card"
          >
            <MedicalRecordItem :medicalRecord="item" />
          </div>
        </div>
      </div>
      <footer class="pagination-records">
        <v-pagination
          v-if="searchMode === 'medicalRecords'"
          v-model="pageRecord"
          :length="createPagination(listRecords).length"
        ></v-pagination>
        <v-pagination
          v-else
          v-model="pagePatient"
          :length="createPagination(listPatients).length"
        ></v-pagination>
      </footer>
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import DatePicker from '@/components/DatePicker';
import MedicalRecordItem from '@/components/MedicalRecordItem';
import { getAllMedicalRecords } from '../../services/psychologists';
import Api from '../../services/httpClient';

export default {
  data() {
    return {
      cod: '',
      searchNamePatient: '',
      listPatients: [],
      listaProntuarios: [],
      listRecords: [],
      filterFocused: false,
      pageRecord: 1,
      pagePatient: 1,
      searchOptionsItems: [
        {
          title: 'Pacientes',
          value: 'patients',
        },
        {
          title: 'Prontuários',
          value: 'medicalRecords',
        },
      ],
      searchMode: 'patients',
      dataSearch: {
        name: '',
        initialDate: '',
        finalDate: new Date().toISOString().substr(0, 10),
      },
      date: '',
      iconSelect: 'hearing',
    };
  },
  components: {
    DatePicker,
    MedicalRecordItem,
  },
  async created() {
    this.$startLoading();
    await this.getCod();
    // await this.getMyMedicalRecords();
    // await this.getListPatients('matheus');
    this.searchMode === 'patients';
    this.getDataFromSearchMode();
  },
  computed: {
    ...mapState('loading', {
      isLoading: 'isLoading',
    }),
  },
  methods: {
    clearForm() {
      this.dataSearch.name = '';
      this.dataSearch.initialDate = '';
      this.dataSearch.finishDate = new Date().toISOString().substr(0, 10);
      this.searchMode = 'patients';
      this.getDataFromSearchMode();
      setTimeout(() => {
        this.searchMode = 'medicalRecords';
        this.getDataFromSearchMode();
      }, 5);
    },
    saveDate(value, field) {
      console.log(value, field);
      if (field === 'beginningDate') {
        this.dataSearch.initialDate = value;
      } else {
        this.dataSearch.finalDate = value;
      }
    },
    getDataFromSearchMode() {
      this.$nextTick(() => {
        if (this.searchMode === 'patients') {
          this.getListPatients();
          this.iconSelect = 'record_voice_over';
        } else {
          this.getMyMedicalRecords();
          this.iconSelect = 'content_paste';
        }
      });
    },
    createPagination(data) {
      const cache = [];
      let i = 0;
      while (i < data.length) {
        cache.push(data.slice(i, i + 10));
        i += 10;
      }
      return cache;
    },
    async getMyMedicalRecords() {
      this.$startLoading();
      if (this.dataSearch.initialDate === '') {
        delete this.dataSearch.initialDate;
      }

      const res = await getAllMedicalRecords(this.dataSearch);
      if (res.status === 200) {
        this.listRecords = res.data.results;
      }
      this.$stopLoading();
    },
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async getListPatients(namePatient) {
      this.$startLoading();
      try {
        const { data, status } = await Api.get(`psychologists/${this.cod}/only_patients/`, {
          params: {
            name: namePatient,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        });
        if (status === 200) {
          // eslint-disable-next-line prefer-destructuring
          this.listPatients = data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$stopLoading();
      }
    },
    goProfilePatients(id) {
      this.$router.push({ name: 'PacienteProfile', params: { id } });
    },
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.bt-perfil {
  font-size: 0.5rem;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.box-paciente {
  width: 100%;
  border-radius: 5px;
}

.col-paciente:nth-child(odd) .box-paciente {
  background-color: #fffde3;
}

.paciente-nome {
  font-size: 1rem;
}
.card-container-filter {
  width: 100%;
  display: flex;
  max-width: 500px !important;
  position: relative;
}
.filter-position {
  width: 27px;
  z-index: 6;
  top: 14px;
  left: 10px;
  margin-right: 2px;
  position: absolute;
}
.grid-records {
  display: grid;
  grid-template-columns: repeat(auto-fit, min(100%, 550px));
  justify-content: space-around;
  grid-gap: 10px;
}
.grid-records > div {
  width: 100% !important;
}
.grid-card {
  padding: 10px 20px;
  background: #f8f8f8;
  border-radius: 5px;
}
.filter-position-two {
  width: 27px;
  z-index: 6;
  top: 18px;
  left: 10px;
  margin-right: 2px;
  position: absolute;
}
.card-container-filter > div {
  width: 100% !important;
}
.card-input {
  margin: 0px 10px;
  max-width: 150px;
}
.search-records {
  width: 100%;
  margin: 40px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-records {
  margin-top: 30px;
}
.search-records button {
  display: block;
  margin: 0px 10px;
}

.search-patients {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
}
.search-patients > div {
  width: 100%;
  max-width: 600px;
  display: flex;
  align-items: center;
}

.search-patients > div > div {
  width: 100%;
}
.search-patients > div > div > div:last-child {
  width: 100%;
  max-width: 400px !important;
}
.search-patients > div > button {
  width: 90%;
  max-width: 200px !important;
  display: block;
  margin: 0px 10px;
}

.box-paciente img {
  width: 55px;
  height: 55px;
  border-radius: 50% !important;
  border: 1px solid #ccc;
}

@media screen and (max-width: 620px) {
  .search-records {
    display: flex;
    padding: 0px 10px;
    flex-direction: column !important;
  }
  .card-input {
    width: 100% !important;
    max-width: none !important;
    margin: 10px 0px;
  }
  .search-records button,
  .search-patients button {
    width: 100% !important;
    margin-bottom: 5px;
  }
  .search-patients {
    padding: 0px 12px;
  }
  .search-patients > div > div {
    margin: 5px 0px;
  }
  .search-patients > div {
    flex-direction: column !important;
  }
}
@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
